import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


const imageUrls = [
  "https://catherinebest.com/cdn/shop/products/Bcf6057yw_201_1_1024x.png?v=1649186882",
  "https://catherinebest.com/cdn/shop/products/Bcf6057yw_1_848dcfdd-b3aa-4d15-a3da-f40ab77184ee_1024x.png?v=1649176882"
]

const ProductSlider = () => {
    const settings = {
        customPaging: function(i) {
          return (
            <button
              key={i}
              type="button"
              className="focus:outline-none"
              style={{ background: "none", border: "none", padding: 0, cursor: "pointer" }}
              tabIndex={0}
              aria-label={`Go to slide ${i + 1}`}
            >
              <img className='w-9' src={imageUrls[i]} alt={`Slide ${i+1}`} />
            </button>
          );
        },
        dots: true,
        dotsClass: "slick-dots slick-thumb",
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay : true,
        arrows : false
      };
  return (
    <section className='w-[52%] max-sm:w-[100%] justify-center items-center md:ml-[166px]'>
        <Slider {...settings}>
          {imageUrls.map((url,index)=>(
          <div>
            <img src={url} alt='products' />
          </div>
          ))}
        </Slider>
    </section>
  )
}

export default ProductSlider


